// 格式化时间
function formatTime(date, format = null) {
  var daDate = new Date(date * 1000),
      // 毫秒级
  formatsArr = ['Y', 'M', 'D', 'h', 'i', 's'],
      returnArr = [],
      year = daDate.getFullYear(),
      month = daDate.getMonth() + 1,
      day = daDate.getDate(),
      hour = daDate.getHours(),
      minute = daDate.getMinutes(),
      second = daDate.getSeconds();

  function formatNumber(n) {
    n = n.toString();
    return n[1] ? n : '0' + n;
  }

  if (format === null) {
    return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':');
  } else {
    returnArr.push(year);
    returnArr.push(formatNumber(month));
    returnArr.push(formatNumber(day));
    returnArr.push(formatNumber(hour));
    returnArr.push(formatNumber(minute));
    returnArr.push(formatNumber(second));

    for (let i in returnArr) {
      format = format.replace(formatsArr[i], returnArr[i]);
    }

    return format;
  }
} 

// AJAX 请求
// function request(url, method = 'GET', data = {}) {
//   let header = {
//     'content-type': 'application/json',
//     'X-ECAPI-Sign': '',
//     'X-ECAPI-UDID': '',
//     'X-ECAPI-UserAgent': 'Platform/Wechat',
//     'X-ECAPI-Ver': '1.1.0'
//   };
//   let token = uni.getStorageSync('api_token') || '';
//   if (token) {
//     header['X-ECAPI-Authorization'] = token;
//   }
//   return new Promise(function (resolve, reject) {
   
//   });
// } 

// 复制信息
function copyMessage(data){
  return new Promise((resolve,reject)=>{
    // #ifdef H5
    let result
    let textarea = document.createElement('textarea')
    textarea.value = data
    textarea.readOnly = "readOnly"
    document.body.appendChild(textarea)
    textarea.select()
    textarea.setSelectionRange(0,data.length)
    resolve({})
    result = document.execCommand("copy")
    textarea.remove()
    // #endif
  })


}

function getUserInfo(){
  let plat = getAppPlat()
  //此时先清空保存的token信息
  if(plat === 'ios'){
    return new Promise((resolve,reject)=>{
      // resolve();return;
      setupWebViewJavascriptBridge(bridge=> {
        bridge.callHandler('getUserInfo','', responseData=>{
          let result = JSON.parse(responseData)
          if(result.token){
            resolve(result.token)
          }else {
            reject()
          }
        })
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        let result = window.nativeBridge.getUserInfo();
        result?resolve(result.getToken()):reject()
      }
    })
  }
}

function getAppMallToken(){
  let plat = getAppPlat()
  //此时先清空保存的token信息

  if(plat === 'ios'){
    return new Promise((resolve,reject)=>{
      // resolve();return;
      setupWebViewJavascriptBridge(bridge=> {
        bridge.callHandler('getUSMallToken','', responseData=>{
          let result = JSON.parse(responseData)
          if(result.token){
            resolve(result.token)
          }else {
            reject()
          }
        })
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        let result = window.nativeBridge.getUSMallToken();
        result?resolve(result):reject()
      }
    })
  }
}

function hideAppTabBar(hide){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('hideTabbar',hide, responseData=>{
      })
    })
  }else {
    if(window.nativeBridge){
      if(hide){
        window.nativeBridge.hideTabBar();
      }else {
        window.nativeBridge.showTabBar();
      }

    }
  }
}

function setStatusBarHeight(height){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('setWebViewOriginY',height, responseData=>{
        resolve(responseData)
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        window.nativeBridge.setWebViewOriginY(height);
      }
    })
  }
}

function getAppCurrentMode(){
  let plat = getAppPlat()
  // uni.setStorageSync('userInfo',null)
  // uni.setStorageSync('api_token','');
  if(plat === 'ios'){
    return new Promise((resolve,reject)=> {
      setupWebViewJavascriptBridge(bridge=> {
        bridge.callHandler('isDarkMode','', responseData=>{
          responseData?resolve({plat:plat,isDark:true}):reject()
        })
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        let result = window.nativeBridge.isDarkMode();
        result?resolve({plat:plat,isDark:true}):reject()
      }
    })
  }
}

function jumpToAppBindMoile(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('bindMobile','', responseData=>{
        resolve(responseData)
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        let result = window.nativeBridge.bindMobile();
        result?resolve(result):reject()
      }
    })
  }
}

function jumpToAppBindEmail(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('bindEmail','', responseData=>{
        resolve(responseData)
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        let result = window.nativeBridge.bindEmail();
        result?resolve(result):reject()
      }
    })
  }
}

function closeCurrentPage(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    setupWebViewJavascriptBridge(bridge=> {
      bridge.callHandler('closeCurrentPage','', responseData=>{
      })
    })
  }else {
    if(window.nativeBridge){
      let result = window.nativeBridge.closeCurrentPage();
    }
  }
}
function uploadImgByApp(){
  let plat = getAppPlat()
  if(plat === 'ios'){
    return new Promise((resolve,reject)=> {
      setupWebViewJavascriptBridge(bridge=> {
        bridge.callHandler('getSystemMedia','', responseData=>{
          responseData?resolve({responseData}):reject()
        })
        resolve()
      })
    })
  }else {
    return new Promise((resolve,reject)=>{
      if(window.nativeBridge){
        let result = window.nativeBridge.getSystemMedia();
        result?resolve(result):reject()
      }
    })
  }
}

function getAppPlat(){
  // #ifdef H5
  let u = navigator.userAgent;
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isiOS) {
    return "ios";
  } else {
    return "android";
  }
  // #endif
}

function checkAppPayIsInstalled(payMethod){
  let plat = getAppPlat()
  if(plat === 'ios'){
    return new Promise((resolve,reject)=> {
      setupWebViewJavascriptBridge(bridge => {
        if (payMethod === 'weixin') {
          //检测微信是否安装
          bridge.callHandler('isWXAppInstalled', '', responseData => {
            responseData?resolve(true):resolve(false)
          })
        } else {
          //检测支付宝是否安装
          bridge.callHandler('isAliPayAppInstalled', '', responseData => {
            responseData?resolve(true):resolve(false)
          })
        }
      })
    })
  }else {
    if(window.nativeBridge){
      return new Promise((resolve,reject)=> {
        if (payMethod === 'weixin') {
          //检测微信是否安装
          let result = window.nativeBridge.isWXAppInstalled();
          result?resolve(true):resolve(false)
        } else {
          //检测支付宝是否安装
          let result = window.nativeBridge.isAliPayAppInstalled();
          result?resolve(true):resolve(false)
        }
      })
    }
  }
}

function setupWebViewJavascriptBridge(callback){
  if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }
  if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'https://__bridge_loaded__';
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
}

// function setCookie(name,value,domain,exdays=1){
//   let exdate = new Date()
//   exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays)
//   window.document.cookie = name + '=' + encodeURIComponent (value) + ';path=/;expires=' + exdate.toGMTString() + ';domain=.roborock.com'
// }

